<template>
  <div class="tab-container">
    <ActionModal
      modal="archive"
      :data="data"
      :isOpen="state.showActionModal"
      @close="state.showActionModal = false"
      @confirm="confirm"
    />
    <div class="tab-section">
      <div class="title">Archiver ma campagne</div>
      <p class="muted">
        L’archivage de votre campagne n’est pas définitif, vous pourrez la
        restaurer à tout moment depuis votre page organisation. Pour archiver
        votre campagne, cliquez sur le bouton ci-dessous.
      </p>
      <Button
        class="primary"
        label="Archiver ma campagne"
        :disabled="!canArchive"
        @click="state.showActionModal = true"
      />
      <p
        v-if="!canArchive"
        class="muted"
        v-text="
          'Archivage de campagne actuellement indisponible car des talents sont encore en cours d’évaluation.'
        "
      />
    </div>
  </div>
</template>

<script setup>
import { reactive, computed } from "vue";
import { useParticipantStore } from "@/stores/participant.js";
import ActionModal from "@/components/modals/app/actionModal/ActionModal.vue";

const emits = defineEmits(["archive"]);

const { inProgressParticipants } = useParticipantStore();

const canArchive = computed(() => {
  if (!inProgressParticipants) return true;

  return inProgressParticipants.filter((elt) => elt.state === 1).length < 1;
});

defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const state = reactive({
  showActionModal: false,
});

function confirm() {
  state.showActionModal = false;
  emits("archive");
}
</script>
